/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-nested-ternary */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/camelcase */
import React, { useContext, useEffect, useState } from 'react';
import ThankYouPopup from './ThankYouPopup';
import PrivacyPolicyForm from './PrivacyPolicyForm';
import {
  conditionState,
  formObject,
  actionSubjectObjectType
} from '../../types/regulatoryUpdateBundle';
import Input from '../../components/Input/Input';
import GlobalContext from '../../contexts/GlobalContext';
import { actionData, subjectValue } from '../../utils/regulatoryUpdatesBundle';
type LoggedOutPopupProps = {
  setClosePopup: Function;
  triggerActionGaEvent: Function;
};

const RegulatoryUpdateBundleLoggedOutPopup = (
  props: LoggedOutPopupProps
): JSX.Element => {
  const actionSubjectObject: actionSubjectObjectType = {
    actionValue: '',
    subjectValue: ''
  };
  const globalContextValue = useContext(GlobalContext);
  const { globalContext } = globalContextValue;
  const [actionSubjectValue, setActionSubjectValue] =
    useState(actionSubjectObject);
  const [condition, setCondition] = useState(conditionState);
  const [apiError, setApiError] = useState(false);
  const [successScreenFlag, setSuccessScreenFlag] = useState(false);
  const [successScreenPopUpText, setSuccessScreenPopUpText] = useState('');
  const [customerObject, setCustomerObject] = useState(formObject);
  const [agentObject, setAgentObject] = useState(formObject);
  const setSubjectTypeValue = (value): void => {
    let localConditionObject = condition;

    if (actionSubjectValue.actionValue === '') {
      localConditionObject = {
        ...localConditionObject,
        actionError: true,
        disableCheck: true
      };
    } else {
      let actionSubjectValueObj = actionSubjectValue;

      actionSubjectValueObj = { ...actionSubjectValueObj, subjectValue: value };
      setActionSubjectValue(actionSubjectValueObj);

      if (value === subjectValue.CUSTOMER) {
        localConditionObject = {
          ...localConditionObject,
          loginComponent: true,
          agentForm: false,
          loginCheck: false,
          customerForm: false
        };
      } else {
        localConditionObject = {
          ...localConditionObject,
          customerForm: true,
          agentForm: true,
          loginCheck: true,
          loginComponent: false
        };
      }
    }

    setCondition(localConditionObject);
  };
  const setActionValueInState = (value: string): void => {
    let actionSubjectValueObj = actionSubjectValue;

    props.triggerActionGaEvent(value);
    actionSubjectValueObj = { ...actionSubjectValueObj, actionValue: value };
    setActionSubjectValue(actionSubjectValueObj);

    let localConditionObject = condition;

    localConditionObject = {
      ...localConditionObject,
      actionError: false,
      disableCheck: false
    };
    setCondition(localConditionObject);
  };
  const showCustomerForm = (): void => {
    let localConditionObject = condition;

    globalContext.gtm.pushVersionedEvent(
      '2.11',
      'CCPARequest',
      'ClickContinueWithoutLoginButton',
      '',
      null,
      true
    );
    localConditionObject = {
      ...localConditionObject,
      loginCheck: true,
      loginComponent: false,
      customerForm: true,
      agentForm: false
    };
    setCondition(localConditionObject);
  };
  const closePopup = (): void => {
    props.setClosePopup(false);
  };

  const closePopupWithCrossIcon = (): void => {
    props.setClosePopup(false);

      document.body.classList.remove('is-reveal-open');
      globalContext.gtm.pushVersionedEvent(
        '2.11',
        'CCPARequest',
        'ClickCloseIcon',
        '',
        null,
        true
      );

  };
  const saveRadioButtonValues = (): void => {
    if (actionSubjectValue.actionValue === actionData.RETRIEVE) {
      globalContext.gb.utils.saveToStore('retrieverequestat', true);
    }

    if (actionSubjectValue.actionValue === actionData.DELETE) {
      globalContext.gb.utils.saveToStore('deletionrequestat', true);
    }
  };
  const removeopenManageAccountScreenFlagFromStore = (): void => {
    globalContext.gb.utils.removeFromStore('openManageAccountScreen');
  };
  const openLoginPopUp = (): void => {
    globalContext.gtm.pushVersionedEvent(
      '2.11',
      'CCPARequest',
      'ClickLoginButton',
      '',
      null,
      true
    );
    props.setClosePopup(false);
    globalContext.gb.utils.saveToStore('openLoginModelThroughCCPALink', true);
    globalContext.gb.utils.saveToStore('openManageAccountScreen', true);
    saveRadioButtonValues();
    globalContext.Backbone.trigger('openLoginPopup');
    // eslint-disable-next-line no-unused-expressions
    document
      ?.getElementById('close_login_n_create_account_popUp')
      ?.addEventListener('click', removeopenManageAccountScreenFlagFromStore);
  };

  useEffect(() => {
    let localConditionObject = condition;

    globalContext.gtm.pushVersionedEvent(
      '2.11',
      'CCPARequest',
      actionSubjectValue.subjectValue === subjectValue.AGENT &&
        actionSubjectValue.actionValue
        ? 'ClickAgentCheckbox'
        : 'ClickCustomerCheckbox',
      '',
      null,
      true
    );

    if (
      actionSubjectValue.subjectValue === subjectValue.AGENT &&
      actionSubjectValue.actionValue
    ) {
      localConditionObject = {
        ...localConditionObject,
        customerForm: true,
        agentForm: true
      };
    }

    if (
      actionSubjectValue.subjectValue === subjectValue.CUSTOMER &&
      actionSubjectValue.actionValue
    ) {
      localConditionObject = {
        ...localConditionObject,
        customerForm: true,
        agentForm: false
      };
    }

    setCondition(localConditionObject);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actionSubjectValue.subjectValue]);

  return (
    <div className="regulatory-updates-modal__inner">
      {!successScreenFlag && (
        <div>
          <button
            className="close-button"
            data-close=""
            aria-label="Close modal"
            type="button"
            onClick={(): void => {
              closePopupWithCrossIcon();
            }}>
            <span aria-hidden="true" className="close-button__icon">
              ×
            </span>
          </button>
          <div className="regulatory-updates-modal__header">
            <h2 className="regulatory-updates__heading js-regulatory-updates-modal-heading">
              Privacy Requests
            </h2>
          </div>
          <form
            method="post"
            className="form-wrapper privacy-ccpa-form"
            acceptCharset="UTF-8">
            <input
              type="hidden"
              defaultValue="privacy_ccpa_form"
              name="form_type"
            />
            <input type="hidden" name="utf8" defaultValue="✓" />
            <input
              type="hidden"
              className="validate-form-info"
              data-msg="loginError"
            />
            <div className="regulatory-updates-modal__values">
              <div className="regulatory-updates-modal__values-area privacy-ccpa__wantto">
                <div className="privacy-ccpa-options">
                  <p className="regulatory-updates__para regulatory-updates__para--privacy-options">
                    I want to:
                  </p>
                  <ul className="radio-options privacy-ccpa__list">
                    <li className="radio-options__li">
                      <Input
                        id={'retrieve-data-option'}
                        name="want_data_options"
                        onChange={(e): void =>
                          setActionValueInState(e.target.value)
                        }
                        type="radio"
                        value={actionData.RETRIEVE}
                      />
                      <label
                        htmlFor="retrieve-data-option"
                        className="radio-options__label">
                        Retrieve a copy of my data
                      </label>
                    </li>
                    <li className="radio-options__li">
                      <Input
                        id={'delete-data-option'}
                        name="want_data_options"
                        onChange={(e): void =>
                          setActionValueInState(e.target.value)
                        }
                        type="radio"
                        value={actionData.DELETE}
                      />
                      <label
                        htmlFor="delete-data-option"
                        className="radio-options__label">
                        Request the deletion of my data
                      </label>
                    </li>
                  </ul>
                  {condition.actionError && (
                    <span
                      id="input-field-error-action-type"
                      className="real-time-error">
                      Please Select Action
                    </span>
                  )}
                </div>
                <div className="privacy-ccpa-options">
                  <p className="regulatory-updates__para regulatory-updates__para--privacy-options">
                    I am:
                  </p>
                  <ul className="radio-options privacy-ccpa__list">
                    <li className="radio-options__li">
                      <Input
                        type="radio"
                        id="customer-data-option"
                        name="am_data_options"
                        value={subjectValue.CUSTOMER}
                        disabled={condition.disableCheck}
                        onChange={(e): void =>
                          setSubjectTypeValue(e.target.value)
                        }
                      />
                      <label
                        htmlFor="customer-data-option"
                        className="radio-options__label"
                        onClick={(): void => {
                          setSubjectTypeValue(subjectValue.CUSTOMER);
                        }}>
                        A Customer
                      </label>
                    </li>
                    <li className="radio-options__li">
                      <Input
                        type="radio"
                        id="agent-data-option"
                        name="am_data_options"
                        value={subjectValue.AGENT}
                        disabled={condition.disableCheck}
                        onChange={(e): void =>
                          setSubjectTypeValue(e.target.value)
                        }
                      />
                      <label
                        htmlFor="agent-data-option"
                        className="radio-options__label"
                        onClick={(): void => {
                          setSubjectTypeValue(subjectValue.AGENT);
                        }}>
                        An Authorized Agent
                      </label>
                    </li>
                  </ul>
                </div>
              </div>
              {condition.loginComponent && (
                <div>
                  <button
                    className="base-button base-button--full-width regulatory-updates-modal__btn sj-button base-button--activation"
                    type="submit"
                    onClick={(): void => openLoginPopUp()}>
                    log in
                  </button>
                  <button
                    className="base-button base-button--full-width regulatory-updates-modal__btn regulatory-updates-modal__btn--secondary sj-button base-button--inverted"
                    type="button"
                    onClick={(): void => {
                      showCustomerForm();
                    }}>
                    continue without logging in
                  </button>
                </div>
              )}
              <div className="privacy-ccpa-customer-agent-sections">
                {
                  <PrivacyPolicyForm
                    customer={customerObject}
                    agent={agentObject}
                    setAgentObject={setAgentObject}
                    setCustomerObject={setCustomerObject}
                    condition={condition}
                    apiError={apiError}
                    actionSubjectValue={actionSubjectValue}
                    setApiError={setApiError}
                    setThankYouScreenFlag={setSuccessScreenFlag}
                    setSuccessScreenPopUpText={setSuccessScreenPopUpText}
                  />
                }
              </div>
              <p className="privacy-ccpa__disclaimer">
                For any other requests, please email{' '}
                <a
                  href={
                    'mailto:' + globalContext.gb.liquid.settings.contact_email
                  }
                  className="privacy-ccpa__disclaimer-link">
                  {globalContext.gb.liquid.settings.contact_email}
                </a>
              </p>
            </div>
            {(condition.loginCheck || condition.loginComponent) && (
              <div className="captcha-note">
                This site is protected by reCAPTCHA and the Google{' '}
                <a
                  href="https://policies.google.com/privacy"
                  target="_blank"
                  className="captcha-note__link">
                  Privacy Policy
                </a>{' '}
                and{' '}
                <a
                  href="https://policies.google.com/terms"
                  target="_blank"
                  className="captcha-note__link">
                  Terms of Service
                </a>{' '}
                apply.
              </div>
            )}
          </form>
        </div>
      )}
      {successScreenFlag && (
        <ThankYouPopup
          closePopUp={closePopup}
          message={successScreenPopUpText}
        />
      )}
    </div>
  );
};

export default RegulatoryUpdateBundleLoggedOutPopup;
